import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '@shared/hooks/index.ts';
import { useCommonMenu } from '@shared/ui';
import { checkEventEnd } from 'library/helpers/events/dateSets';
import { useDelete, usePublicate, useShare } from 'library/hooks/events';
// import { useUser } from 'library/hooks/user';
import type { Event } from 'library/models/events';

type Props = {
  event: Event;
  hasTickets: boolean;
};

const useMenu = ({ event, hasTickets }: Props) => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { deleteEvent } = useDelete();
  const { goToPublicationPage } = usePublicate();
  const { openShare } = useShare();
  const { code } = useParams<{ code: string }>();

  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();

  const isAuthor = React.useCallback(() => {
    return user?.id === event.author.id;
  }, [event?.author.id, user]);

  const share = () => {
    openShare(event.id);
  };

  const publication = () => {
    goToPublicationPage(event.id);
  };

  const edit = () => {
    navigate(`/events/${code}/${event.id}/edit`);
  };

  const remove = () => {
    deleteEvent(event.id, hasTickets);
  };

  const duplicate = () => {
    navigate(`/events/${code}/create`, { state: { copyEventId: event.id } });
  };

  const getItems = () => {
    let items = [
      {
        title: 'Поделиться',
        action: share,
      },
    ];

    if (isAuthor()) {
      if (checkEventEnd(event.time_to)) {
        return (items = [
          {
            title: 'Удалить',
            action: remove,
          },
          {
            title: 'Дублировать',
            action: duplicate,
          },
        ]);
      }

      items.push({
        title: 'Публикация',
        action: publication,
      });

      items.push({
        title: 'Изменить',
        action: edit,
      });

      items.push({
        title: 'Удалить',
        action: remove,
      });
    }

    return items;
  };

  return {
    open,
    items: getItems(),
    onOpen,
    onClose,
    setReferenceEl,
    referenceEl,
    popperEl,
    setPopperEl,
  };
};

export default useMenu;
